export default __webpack_public_path__ + "static/media/dots.9ec7eca4.svg";